<template>
  <div class="item-book-shortcut-line">
    <div class="item-book-name">
      {{ this.item.book.name }}
      {{ this.item.book.volume }}
    </div>

    <div class="shortcut-input">
      <span v-show="!editMode" class="shortcut-char">{{ this.item.char }}</span>
      <input
        v-show="editMode"
        @keyup.enter="save"
        @input="setName"
        @keydown="setChar"
        ref="editBox"
        type="text"
        :value="editedText"
        class="small-input"
        maxlength="1"
      />
      <span class="plus-text"> + </span>
      <span class="short-text">{{ this.item.short }}</span>
      <div class="vertical-separate"></div>
      <span
        v-show="editMode"
        @click.stop="save"
        class="otz-icon icon-v set-icon"
        >A</span
      >
      <span
        v-show="editMode"
        class="otz-icon icon-x x-icon set-icon"
        @click.stop="editMode = false"
        >F</span
      >
      <Icons
        icon="editPencil"
        width="16"
        height="14"
        v-show="!editMode"
        @click.stop="doEdit"
      ></Icons>
      <div v-show="!editMode" @click="remove" class="icon-trash icon-otzar">
        9
      </div>
    </div>
  </div>
</template>

<script>
import Icons from "@/components/Icons/Icons.vue";

export default {
  components: { Icons },
  props: ["item"],
  data() {
    return {
      editMode: false,
      editedText: this.item.char,
      keyCode: "",
      lastKeyCode: "",
    };
  },
  methods: {
    save() {
      this.editMode = false;
      if (this.$refs.editBox.value.trim() == "") return;
      this.editedText = this.$refs.editBox.value.trim();
      if (this.editedText.length != 1 || !this.keyCode) return;
      this.$emit("save", this.item, this.editedText, this.keyCode);
    },
    doEdit() {
      this.editMode = true;
      this.$nextTick(() => {
        this.$refs.editBox.select();
      });
    },
    async remove() {
      this.$emit("remove", this.item);
    },
    setChar(event) {
      this.lastKeyCode = event.code;
    },
    setName(event) {
      this.keyCode = this.lastKeyCode;
    },
  },
};
</script>

<style lang="scss" scoped>
.item-book-shortcut-line {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
}
.shortcut-input {
  // direction: ltr;
  display: flex;
  align-items: center;
  gap: 3px;
}
.item-book-name {
  text-align: right;
}
.shortcut-char {
  color: var(--custom-color1);
  text-align: center;
  font-family: "Noto Sans Hebrew";
  font-size: 13px;
  font-style: normal;
  font-weight: bold;
  line-height: 120%; /* 18px */
  display: flex;
  padding: 4px;
  // flex-direction: column;
  align-items: center;
  gap: 1px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.15);
  height: 17px;
  width: 17px;
  // align-self: stretch;
}
.small-input {
  display: flex;
  padding: 4px;
  flex-direction: column;
  align-items: center;
  gap: 1px;
  border-radius: 4px;
  border: 1px solid var(--custom-color1);
  background: rgba(0, 0, 0, 0.05);
  width: 17px;
  height: 17px;
  color: #626262;
  text-align: center;
  font-family: "Noto Sans Hebrew";
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 18px */
}
.shortcut-char:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15); /* צללית חזקה יותר בהובר */
}
.short-text {
  display: flex;
  padding: 4px 0px;
  align-items: center;
  gap: 1px;
  color: #b9b9b9;
  text-align: center;
  font-family: "Noto Sans Hebrew";
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 18px */
  text-transform: capitalize;
}
.plus-text {
  color: #b9b9b9;

  text-align: center;
  font-family: "Noto Sans Hebrew";
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%; /* 15.6px */
  display: flex;
  align-items: center;
  gap: 4px;
}

.vertical-separate {
  border-left: 1px solid #ececec;
  margin-left: 6px;
  margin-right: 5px;
  height: 14px;
}
.icon-trash {
  border-radius: 20px;
  line-height: 16px;
  width: 17px;
  font-size: 18px !important;
  margin: 0 3px;
  transition: 0.3s;
  &:hover {
    background-color: #00000038;
  }
}
.set-icon {
  width: 15px;
}
.x-icon {
  margin-right: 3px;
}
</style>
